import React from 'react'
import authRoute from './authRoute'

export const publicRoutes = [...authRoute]

export const protectedRoutes = [
    {
        key: 'dashboard',
        path: '/dashboard',
        component: React.lazy(() => import('views/dashboard/')),
        authority: [],
    },
    {
        key: 'department.view',
        path: '/department',
        component: React.lazy(() => import('views/department/Department')),
        authority: [],
    },
    {
        key: 'testimony-wall.view',
        path: '/testimony-wall',
        component: React.lazy(() =>
            import('views/testimony-wall/TestimonyWall')
        ),
        authority: [],
    },
    {
        key: 'formsMenu.child-dedication',
        path: '/forms/child-dedication',
        component: React.lazy(() => import('views/forms/ChildDedication')),
        authority: [],
    },
    {
        key: 'formsMenu.child-dedication-view',
        path: '/forms/child-dedication/:id',
        component: React.lazy(() => import('views/forms/ChildDedicationView')),
        authority: [],
    },
    {
        key: 'formsMenu.naming-ceremony',
        path: '/forms/naming-ceremony',
        component: React.lazy(() =>
            import('views/forms/NamingCeremony/NamingCeremony')
        ),
        authority: [],
    },
    {
        key: 'formsMenu.naming-ceremony-view',
        path: '/forms/naming-ceremony/:id',
        component: React.lazy(() =>
            import('views/forms/NamingCeremony/ViewNamingCeremony')
        ),
        authority: [],
    },
    {
        key: 'formsMenu.testimony',
        path: '/forms/testimony',
        component: React.lazy(() => import('views/forms/Testimony/Testimony')),
        authority: [],
    },
    {
        key: 'formsMenu.testimony-view',
        path: '/forms/testimony/:id',
        component: React.lazy(() =>
            import('views/forms/Testimony/ViewTestimony')
        ),
        authority: [],
    },
    {
        key: 'formsMenu.wedding-anniversary',
        path: '/forms/wedding-anniversary-thanksgiving',
        component: React.lazy(() =>
            import('views/forms/WeddingAnniversary/WeddingAnniversary')
        ),
        authority: [],
    },
    {
        key: 'formsMenu.wedding-anniversary-view',
        path: '/forms/wedding-anniversary-thanksgiving/:id',
        component: React.lazy(() =>
            import('views/forms/WeddingAnniversary/ViewWeddingAnniversary')
        ),
        authority: [],
    },
    {
        key: 'formsMenu.wedding-thanksgivng',
        path: '/forms/wedding-thanksgiving',
        component: React.lazy(() =>
            import('views/forms/WeddingThanksGiving/WeddingThanksGiving')
        ),
        authority: [],
    },
    {
        key: 'formsMenu.wedding-thanksgivng-view',
        path: '/forms/wedding-thanksgiving/:id',
        component: React.lazy(() =>
            import('views/forms/WeddingThanksGiving/ViewWeddingThanksGiving')
        ),
        authority: [],
    },
    {
        key: 'formsMenu.first-timer',
        path: '/forms/first-timer',
        component: React.lazy(() =>
            import('views/forms/FirstTimer/FirstTimer')
        ),
        authority: [],
    },
    {
        key: 'formsMenu.first-timer-view',
        path: '/forms/first-timer/:id',
        component: React.lazy(() =>
            import('views/forms/FirstTimer/ViewFirstTimer')
        ),
        authority: [],
    },
    {
        key: 'formsMenu.baptism',
        path: '/forms/baptism',
        component: React.lazy(() => import('views/forms/Baptism/Baptism')),
        authority: [],
    },
    {
        key: 'formsMenu.baptism-view',
        path: '/forms/baptism/:id',
        component: React.lazy(() => import('views/forms/Baptism/ViewBaptism')),
        authority: [],
    },
    {
        key: 'formsMenu.counselling',
        path: '/forms/counselling',
        component: React.lazy(() =>
            import('views/forms/Counselling/Counselling')
        ),
        authority: [],
    },
    {
        key: 'formsMenu.counselling-view',
        path: '/forms/counselling/:id',
        component: React.lazy(() =>
            import('views/forms/Counselling/ViewCounselling')
        ),
        authority: [],
    },
    {
        key: 'formsMenu.online',
        path: '/forms/online',
        component: React.lazy(() => import('views/forms/Online/Online')),
        authority: [],
    },
    {
        key: 'formsMenu.online-view',
        path: '/forms/online/:id',
        component: React.lazy(() => import('views/forms/Online/ViewOnline')),
        authority: [],
    },
    {
        key: 'formsMenu.prayer',
        path: '/forms/prayer-request',
        component: React.lazy(() => import('views/forms/PrayerRequest/Prayer')),
        authority: [],
    },
    {
        key: 'formsMenu.prayer-view',
        path: '/forms/prayer-request/:id',
        component: React.lazy(() =>
            import('views/forms/PrayerRequest/ViewPrayer')
        ),
        authority: [],
    },
    {
        key: 'formsMenu.contact',
        path: '/forms/contact',
        component: React.lazy(() => import('views/forms/Contact/Contact')),
        authority: [],
    },
    {
        key: 'formsMenu.contact-view',
        path: '/forms/contact/:id',
        component: React.lazy(() => import('views/forms/Contact/ViewContact')),
        authority: [],
    },
    {
        key: 'interestGroupMenu.view',
        path: '/interest-group',
        component: React.lazy(() =>
            import('views/interest-group/InterestGroup')
        ),
        authority: [],
    },
    {
        key: 'interestGroupMenu.edit',
        path: '/interest-group/:id',
        component: React.lazy(() =>
            import('views/interest-group/ViewInterest')
        ),
        authority: [],
    },
    {
        key: 'dcc5000Menu.new-converts.view',
        path: '/dcc5000/converts',
        component: React.lazy(() => import('views/dcc5000/converts/Converts')),
        authority: [],
    },
    {
        key: 'dcc5000Menu.new-converts.edit',
        path: '/dcc5000/converts/:id',
        component: React.lazy(() =>
            import('views/dcc5000/converts/ViewConverts')
        ),
        authority: [],
    },
    {
        key: 'dcc5000Menu.evangelism.view',
        path: '/dcc5000/evangelism',
        component: React.lazy(() => import('views/dcc5000/Evangelism')),
        authority: [],
    },
    {
        key: 'dcc5000Menu.evangelism.edit',
        path: '/dcc5000/evangelism/:id',
        component: React.lazy(() => import('views/dcc5000/ViewEvangelism')),
        authority: [],
    },
    {
        key: 'sermonMenu.series.create',
        path: '/series/create',
        component: React.lazy(() => import('views/series/CreateSeries')),
        authority: [],
    },
    {
        key: 'sermonMenu.series.view',
        path: '/series',
        component: React.lazy(() => import('views/series/Series')),
        authority: [],
    },
    {
        key: 'sermonMenu.series.edit',
        path: '/series/:id',
        component: React.lazy(() => import('views/series/EditSeries')),
        authority: [],
    },
    {
        key: 'sermonMenu.message.create',
        path: '/message/create',
        component: React.lazy(() => import('views/message/CreateMessage')),
        authority: [],
    },
    {
        key: 'sermonMenu.message.view',
        path: '/message',
        component: React.lazy(() => import('views/message/ShortMessage')),
        authority: [],
    },
    {
        key: 'sermonMenu.message.edit',
        path: '/message/edit/:id',
        component: React.lazy(() => import('views/message/EditMessage')),
        authority: [],
    },
    {
        key: 'sermonMenu.message.video',
        path: '/message/upload/:id',
        component: React.lazy(() => import('views/message/UploadVideo')),
        authority: [],
    },
    {
        key: 'sermonMenu.create',
        path: '/sermon/create',
        component: React.lazy(() => import('views/sermon/CreateSermon')),
        authority: [],
    },
    {
        key: 'sermonMenu.view',
        path: '/sermon',
        component: React.lazy(() => import('views/sermon/Sermon')),
        authority: [],
    },
    {
        key: 'sermonMenu.edit',
        path: '/sermon/:id',
        component: React.lazy(() => import('views/sermon/EditSermon')),
        authority: [],
    },
    {
        key: 'sermonMenu.audio',
        path: '/sermon/upload/:id',
        component: React.lazy(() => import('views/sermon/UploadAudio')),
        authority: [],
    },
    {
        key: 'sermonMenu.featured.view',
        path: '/featured',
        component: React.lazy(() => import('views/featured/FeaturedSermon')),
        authority: [],
    },
    {
        key: 'sermonMenu.featured.create',
        path: '/featured/create',
        component: React.lazy(() => import('views/featured/CreateFeatured')),
        authority: [],
    },
    {
        key: 'devotionalMenu.devotional',
        path: '/devotional',
        component: React.lazy(() => import('views/devotional/Devotion')),
        authority: [],
    },
    {
        key: 'devotionalMenu.create',
        path: '/devotional/create',
        component: React.lazy(() => import('views/devotional/CreateDevotion')),
        authority: [],
    },
    {
        key: 'devotionalMenu.edit',
        path: '/devotional/:id',
        component: React.lazy(() => import('views/devotional/EditDevotion')),
        authority: [],
    },
    {
        key: 'devotionalMenu.resource.view',
        path: '/devotional/resource/:id',
        component: React.lazy(() =>
            import('views/devotional/resource/DevotionResource')
        ),
        authority: [],
    },
    {
        key: 'devotionalMenu.resource.edit',
        path: '/devotional/resource/edit/:id',
        component: React.lazy(() =>
            import('views/devotional/resource/EditResource')
        ),
        authority: [],
    },
    {
        key: 'devotionalMenu.resource.create',
        path: '/devotional/resource/create/:id',
        component: React.lazy(() =>
            import('views/devotional/resource/CreateResource')
        ),
        authority: [],
    },
    {
        key: 'biblePlan.theme',
        path: '/bible-plan/theme',
        component: React.lazy(() => import('views/bibleplan/theme')),
        authority: [],
    },
    {
        key: 'biblePlan.plan',
        path: '/bible-plan/theme/:id/plans',
        component: React.lazy(() => import('views/bibleplan/plan')),
        authority: [],
    },
    {
        key: 'biblePlan.message',
        path: '/bible-plan/plan/:id/message',
        component: React.lazy(() => import('views/bibleplan/message')),
        authority: [],
    },
    {
        key: 'eventCatMenu.view',
        path: '/event/category',
        component: React.lazy(() =>
            import('views/event/category/EventCategories')
        ),
        authority: [],
    },
    {
        key: 'eventMenu.create',
        path: '/event/create',
        component: React.lazy(() => import('views/event/CreateEvent')),
        authority: [],
    },
    {
        key: 'eventMenu.view',
        path: '/event',
        component: React.lazy(() => import('views/event/Events')),
        authority: [],
    },
    {
        key: 'eventMenu.edit',
        path: '/event/:id',
        component: React.lazy(() => import('views/event/EditEvent')),
        authority: [],
    },
    {
        key: 'blogCatMenu.view',
        path: '/blog/category',
        component: React.lazy(() =>
            import('views/blog/category/BlogCategories')
        ),
        authority: [],
    },
    {
        key: 'blogMenu.create',
        path: '/blog/create',
        component: React.lazy(() => import('views/blog/CreateBlog')),
        authority: [],
    },
    {
        key: 'blogMenu.view',
        path: '/blog',
        component: React.lazy(() => import('views/blog/Blogs')),
        authority: [],
    },
    {
        key: 'blogMenu.edit',
        path: '/blog/edit/:id',
        component: React.lazy(() => import('views/blog/EditBlog')),
        authority: [],
    },
    {
        key: 'blogMenu.comments.view',
        path: '/blog/comments',
        component: React.lazy(() => import('views/blog/Comments')),
        authority: [],
    },
    {
        key: 'streamMenu.create',
        path: '/stream/create',
        component: React.lazy(() => import('views/stream/CreateStream')),
        authority: [],
    },
    {
        key: 'streamMenu.view',
        path: '/stream',
        component: React.lazy(() => import('views/stream/Stream')),
        authority: [],
    },
    {
        key: 'streamMenu.edit',
        path: '/stream/edit/:id',
        component: React.lazy(() => import('views/stream/EditStream')),
        authority: [],
    },
    {
        key: 'mobileBannerMenu.create',
        path: '/banner/create',
        component: React.lazy(() => import('views/banner/CreateBanner')),
        authority: [],
    },
    {
        key: 'mobileBannerMenu.view',
        path: '/banner',
        component: React.lazy(() => import('views/banner/Banner')),
        authority: [],
    },
    {
        key: 'settingMenu.livestreaming',
        path: '/settings/live-streaming',
        component: React.lazy(() => import('views/settings/LiveStreaming')),
        authority: [],
    },
    {
        key: 'settingMenu.webBanner',
        path: '/settings/web-banner',
        component: React.lazy(() => import('views/settings/WebBanner')),
        authority: [],
    },
    {
        key: 'settingMenu.form',
        path: '/settings/forms',
        component: React.lazy(() => import('views/settings/Form')),
        authority: [],
    },
    {
        key: 'roleMenu.roles',
        path: '/role',
        component: React.lazy(() => import('views/roles/Roles')),
        authority: [],
    },
    {
        key: 'roleMenu.roles.create',
        path: '/role/create',
        component: React.lazy(() => import('views/roles/CreateRole')),
        authority: [],
    },
    {
        key: 'roleMenu.roles.edit',
        path: '/role/edit/:id',
        component: React.lazy(() => import('views/roles/EditRole')),
        authority: [],
    },
    {
        key: 'userMenu.user.view',
        path: '/user',
        component: React.lazy(() => import('views/user/Users')),
        authority: [],
    },
    {
        key: 'userMenu.user.create',
        path: '/user/create',
        component: React.lazy(() => import('views/user/CreateUser')),
        authority: [],
    },
    {
        key: 'userMenu.user.edit',
        path: '/user/edit/:id',
        component: React.lazy(() => import('views/user/EditUser')),
        authority: [],
    },
    {
        key: 'userMenu.user.profile',
        path: '/user/profile',
        component: React.lazy(() => import('views/user/profile/index')),
        authority: [],
    },
    {
        key: 'transactionMenu.transaction.view',
        path: '/transaction',
        component: React.lazy(() => import('views/transaction/index')),
        authority: [],
    },
    {
        key: 'transactionMenu.transaction.view',
        path: '/transaction/:id',
        component: React.lazy(() =>
            import('views/transaction/ViewTransaction')
        ),
        authority: [],
    },
    {
        key: 'notifyMenu.view',
        path: '/notify',
        component: React.lazy(() => import('views/notify/CreateNotification')),
        authority: [],
    },
]
